import { State } from '@hookstate/core';
import { GameState } from '../stores/backend';
import { useGameType } from './use-game-type';

export const useStripSize = (game: State<GameState>) => {
    const type = useGameType(game);
    return type === 90 ? 6 : 3;
};
